import {Form} from "react-bootstrap";
import './_v-range.scss'
export type VRangeProps = {
    title: string;
    value: number;
    onChange: (value: number) => void;
    min: number;
    max: number;
    step: number;
}

export default function VRange({
                                   title,
                                   value,
                                   onChange,
                                   min,
                                   max,
                                   step
                               }: VRangeProps) {
    return (<div className='v-range-wrapper'>
        <h5 className='v-range-title'>
            {title}
        </h5>
        <Form.Range
            value={value}
            min={min} max={max} step={step}
            onChange={(e) => onChange(Number(e.target.value))}
        />
    </div>);
}
